import { AwaitContainer, Card } from '@ibsys/kit';
import type { FC, ReactNode } from 'react';

type Props = {
  /** Карточка диалога ещё не получена */
  isLoading: boolean;
  children: ReactNode;
};

/** Оболочка панели «Диалог» — у звонка с расшифровкой и у текстовой коммуникации одна. */
export const DialogPanelCard: FC<Props> = ({ isLoading, children }) => (
  <Card className="flex h-full gap-0 p-0">
    <AwaitContainer isLoading={isLoading} className="flex flex-col overflow-hidden rounded-xl">
      {children}
    </AwaitContainer>
  </Card>
);
